import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PrimaryButton } from '../common/Buttons';

import CourseImg1 from '../images/course-img-1.png';
import CourseImg2 from '../images/course-img-2.png';
import CourseImg3 from '../images/course-img-3.png';

import './style.css';

const projects = [
  {
    image: CourseImg1,
    client: 'TechNova',
    goal: 'Redesign their outdated website to drive better conversions and improve UX.',
    result: 'Achieved a 300% increase in organic traffic and a 40% boost in lead conversions within 2 months.',
  },
  {
    image: CourseImg2,
    client: 'EcoMarket',
    goal: 'Build a seamless and scalable e-commerce platform from scratch.',
    result: 'Launched a fully functional store with 150+ monthly sales and high customer retention.',
  },
  {
    image: CourseImg3,
    client: 'AutoSys',
    goal: 'Automate internal processes to reduce operational inefficiencies.',
    result: 'Cut processing time by 40% through a fully integrated automation system.',
  },
];

function WorksSection() {
  return (
    <section id="works" className="works-section">
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3 works-title">
            Our Work
          </h2>
          <p className="lead works-lead">
            Projects that turn ideas into measurable impact
          </p>
        </div>

        <Row>
          {projects.map(({ image, client, goal, result }, index) => (
            <Col key={index} md="6" lg="4" className="mb-5">
              <div className="work-card">
                <img
                  src={image}
                  alt={`Project ${client}`}
                  className="img-fluid rounded mb-3 work-image"
                  loading="lazy"
                />
                <h5 className="mb-1 work-client">
                  {client}
                </h5>
                <p className="work-goal mb-1">
                  <strong>Goal:</strong> {goal}
                </p>
                <p className="work-result mb-0">
                  <strong>Result:</strong> {result}
                </p>
              </div>
            </Col>
          ))}
        </Row>

        <Row className="mt-4">
          <Col className="text-center">
            <PrimaryButton href="/portfolio">
              View Full Portfolio
            </PrimaryButton>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default WorksSection;
